import React, { useEffect,  useState } from "react";
import { withTranslation } from "react-i18next";
import {  useLocation } from "react-router-dom";
import withRouter from "../components/Common/withRouter";
import { useDispatch } from "react-redux";
import { logoutUser, resetReducer as onResetReducer } from "../slice/thunks";
import WebSocketService from "../services/WebsocketService";
import { toast } from "react-toastify";
import { UseSidebarNavigation } from "../components/Hooks/useSidebarNavigation";
import { SidebarItem } from "../components/Global/SidebarItem";

const Sidebar = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [currentSelectedSideBar, setCurrentSelectedSideBar] = useState(null);

  const [webSocketService, setWebSocketService] = useState(null);

  const [currentSideBar, setCurrentSideBar] = useState([
    {
      link: "/dashboard",
      label: "dashboard",
      icon: "fa fa-house me-2",
      children: null,
    },
  ]);

 const {
   sideBarUser,
   sideBarUserLab,
   sideBarAccountant,
   sideBarDoctor,
   sideBarStockController,
   sideBarPharmacisit,
   sideBarCashier,
   sideBarIPD,
   sideBarOPD,
 } = UseSidebarNavigation();

  useEffect(() => {
    setCurrentSideBar([
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
    ]);
  }, []);

  useEffect(() => {
    if (props.currentRole !== null && props.currentPermission !== null) {
      if (props.currentRole && props.currentRole === "DOCTOR") {
        setCurrentSideBar(sideBarDoctor);
      } else if (props.currentRole && props.currentRole === "CASHIER") {
        setCurrentSideBar(sideBarCashier);
      } else if (props.currentRole && props.currentRole === "PHARMACIST") {
        setCurrentSideBar(sideBarPharmacisit);
      } else if (props.currentRole && props.currentRole === "ACCOUNTANT") {
        setCurrentSideBar(sideBarAccountant);
      } else if (props.currentRole && props.currentRole === "LAB_TECHNICIAN") {
        setCurrentSideBar(sideBarUserLab);
      } else if (props.currentRole && props.currentRole === "OPD") {
        setCurrentSideBar(sideBarOPD);
      } else if (props.currentRole && props.currentRole === "IPD") {
        setCurrentSideBar(sideBarIPD);
      } else if (
        props.currentRole &&
        props.currentRole === "STOCK_CONTROLLER"
      ) {
        setCurrentSideBar(sideBarStockController);
      } else {
        setCurrentSideBar(sideBarUser);
      }
    }
  }, [
    props.currentRole,
    props.currentPermission,
    sideBarDoctor,
    sideBarCashier,
    sideBarPharmacisit,
    sideBarAccountant,
    sideBarUserLab,
    sideBarUser,
    sideBarOPD,
    sideBarIPD,
    sideBarStockController,
  ]);

  useEffect(() => {
    const ws = new WebSocketService();
    ws.connect((message) => {
      toast.info(`${message}`);
    });
    setWebSocketService(ws);
    return () => ws.disconnect();
  }, []);

  const doesRouteInclude = (routeValue) => {
    return location.pathname.includes(routeValue);
  };

  const handleLogout = () => {
    dispatch(onResetReducer());
    dispatch(logoutUser(props.router.navigate));
    console.log("user has logged out");
    // if (webSocketService) {
    //   return () => webSocketService.disconnect();
    // }
  };

  const handleOpenMenu = (row) => {
    if (currentSelectedSideBar === row.label) {
    } else {
      setCurrentSelectedSideBar(row.label);
    }
  };

  const handleOpenMenuTop = (row) => {
    if (currentSelectedSideBar === row.label) {
      setCurrentSelectedSideBar(null);
    } else {
      setCurrentSelectedSideBar(row.label);
    }
  };

  return (
    <div className={`sidebar ${props.open ? "open" : ""}`}>
      <nav className="navbar">
        <div className="navbar-nav w-100">
          {currentSideBar.map((item, index) => (
            <SidebarItem
              key={index}
              item={item}
              depth={0}
              t={props.t}
              doesRouteInclude={doesRouteInclude}
            />
          ))}

          <div className="nav-item nav-link" style={{cursor:"pointer"}} onClick={handleLogout}>
            <i className="fa fa-sign-out-alt me-2"></i>
            {props.t("logout")}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default withRouter(withTranslation()(Sidebar));




